import {searchPageAttributesMap, SearchPageType} from '../search/search-config';
import {Translations} from './backendTranslations-types';
import {translationsLoaded} from './backendTranslations-actions';
import {useDispatch} from 'react-redux';
import {useEffect} from 'react';
import {useSearchPageType} from '../search/search-hooks';
import {AbortCategory, fetchJson} from '../services/fetcher';
import {useTranslation} from 'react-i18next';

export const CONFIG_API_ENDPOINT = '/translations';

export const doTranslationsRequest = (
    searchPageType: SearchPageType,
    language: string,
    callback: (Translations) => void
): void => {
    fetchJson<Translations>(
        searchPageAttributesMap[searchPageType].endpoint + CONFIG_API_ENDPOINT + '?language=' + language,
        'GET',
        AbortCategory.TRANSLATIONS
    )
        .then((data: Translations) => {
            callback(data);
        })
        .catch((error) => {
            console.error('failed to fetch translations', error);
        });
};

export function useTranslationsRequest(): void {
    const dispatch = useDispatch();
    const searchPageType = useSearchPageType();
    const {i18n} = useTranslation();

    useEffect(() => {
        doTranslationsRequest(searchPageType, i18n.language, (data) => dispatch(translationsLoaded(data)));
    }, [dispatch, searchPageType, i18n.language]);
}




